import React, { useState, useEffect } from "react";

import AppBar from "@mui/material/AppBar";

import CssBaseline from "@mui/material/CssBaseline";
import SearchBox from "../../common/components/SearchBox";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import AddIcon from "@mui/icons-material/Add";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  Typography,
  Box,
  Button,
  Menu,
  MenuItem,
  IconButton,
  Badge,
  Divider,
  TextField,
  Tooltip,
  List,
  ListSubheader,
  ListItem,
  ListItemText,
  Card,
  Autocomplete,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { connect } from "react-redux";
import { CardContent, Toolbar } from "@mui/material";
import { useHistory } from "react-router-dom";
import {
  getRoles,
  saveRole,
  saveRolePermissions,
  changeRoleStatus,
} from "../../../../store/common/actions";

import moment from "moment";
import ReactPaginate from "react-paginate";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { isEmpty } from "lodash";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";

const RoleManagement = (props) => {
  useEffect(() => {
    document.title = "TMIS | Roles Management";
  }, []);

  const {
    user,
    loading,
    roles,
    getRoles,
    saveRole,
    userModules,
    saveRolePermissions,
    changeRoleStatus,
  } = props;

  useEffect(() => {
    getRoles();
  }, []);

  const [searchTeam, setSearchTeam] = useState("");
  const [filteredItems, setFilteredItems] = useState([...roles]);

  useEffect(() => {
    const filtered = [...roles].filter(({ id }) =>
      (id || "")
        .replace(/\s/g, "")
        .toLowerCase()
        .includes(searchTeam.toLowerCase().replace(/\s/g, "")),
    );
    setFilteredItems(filtered);

    paginate(filtered);
  }, [searchTeam, roles]);

  //PAGINATION
  const [paginatedItems, setPaginatedItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);

  const [itemOffset, setItemOffset] = useState(0);

  const itemsPerPage = 5;

  const paginate = (items) => {
    const endOffset = itemOffset + itemsPerPage;
    setPaginatedItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  };

  useEffect(() => {
    paginate(filteredItems);
  }, [itemOffset, itemsPerPage, filteredItems]);

  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * itemsPerPage) % filteredItems.length || 0;

    setItemOffset(newOffset);
  };

  const getNo = (data, key, idToSearch) =>
    data.findIndex((item) => item[key] === idToSearch);

  const onSearch = (term) => {
    setSearchTeam(term);
  };

  const [showAdd, setShowAdd] = useState(false);
  const [edit, setEdit] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    accessLevel: null,
    roleFeatures: {},
    isActive: true,
  });

  const onClose = () => {
    setFormData({
      id: null,
      accessLevel: null,
      roleFeatures: {},
      isActive: true,
    });
    setEdit(false);
    setShowAdd(false);
  };

  return (
    <div
      style={{
        backgroundColor: "#f3f4f6",
        borderRadius: "0.5rem",
        boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
        MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
        height: "65vh",
        overflowY: "auto",
      }}
      className="px-3"
    >
      <AppBar position="static" elevation={0}>
        <Toolbar
          style={{
            minHeight: "0px",
            // borderBottom: "3px solid #e9ecef",
          }}
          className=" my-0 py-1 bg-white mx-n3"
        >
          <span className="text-uppercase text-primary mr-2">
            Roles Management
          </span>
          <Box sx={{ display: { xs: "flex", md: "flex" } }}>
            <SearchBox onSearch={onSearch} placeholder="Search…" />
          </Box>

          <Box sx={{ flexGrow: 1 }} />

          <Button
            className="ml-1"
            disabled={loading}
            onClick={() => setShowAdd(true)}
            variant="contained"
            size="small"
            disableElevation
            color="primary"
          >
            <AddIcon /> New Role
          </Button>
        </Toolbar>
      </AppBar>
      <div className="mt-2">
        <Card className="border" variant="outlined">
          <div
            style={{
              height: "50vh",
              overflow: "auto",
            }}
          >
            {!!paginatedItems && (
              <List dense component="div">
                {paginatedItems?.map((role) => (
                  <RoleCard
                    userModules={userModules}
                    key={role.id}
                    role={role}
                    index={getNo(filteredItems, "id", role.id)}
                    setFormData={setFormData}
                    setShowAdd={setShowAdd}
                    setEdit={setEdit}
                    saveRolePermissions={saveRolePermissions}
                    changeRoleStatus={changeRoleStatus}
                  />
                ))}
              </List>
            )}
            {!paginatedItems?.length && (
              <div className="jumbotron jumbotron-fluid text-center">
                <div className="container py-5 ">
                  <p className="lead">
                    {loading ? "Fetching data..." : "No record found"}{" "}
                  </p>
                </div>
              </div>
            )}
          </div>

          <ReactPaginate
            breakLabel="..."
            nextLabel={
              <>
                <i className="fas fa-angle-double-right"></i>
              </>
            }
            previousLabel={
              <>
                <i className="fas fa-angle-double-left"></i>
              </>
            }
            pageRangeDisplayed={2}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            pageCount={pageCount}
            renderOnZeroPageCount={null}
            containerClassName="pagination"
            pageLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
            previousLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
            nextLinkClassName="btn btn-outline-dark btn-sm ml-1"
            activeLinkClassName="active"
          />
        </Card>
      </div>
      {showAdd && (
        <AddOrEditRole
          loading={loading}
          showAdd={showAdd}
          formData={formData}
          setFormData={setFormData}
          onClose={onClose}
          saveRole={saveRole}
          edit={edit}
          userModules={userModules}
        />
      )}
    </div>
  );
};

const mapStateToProps = ({ user, loading, roles, userModules }) => {
  return { user, loading, roles, userModules };
};

export default connect(mapStateToProps, {
  getRoles,
  saveRole,
  saveRolePermissions,
  changeRoleStatus,
})(RoleManagement);

const RoleCard = (props) => {
  const {
    loading,
    user,
    role,
    index,
    setFormData,
    setShowAdd,
    setEdit,
    userModules,
    saveRolePermissions,
    changeRoleStatus,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const [showConfirmDisable, setShowConfirmDisable] = useState(false);

  const [selectedFeature, setSelectedFeature] = useState(null);

  const hasFeaturePermissions = (item) => {
    const mod = userModules.find(({ id }) => id === item.moduleId);

    if (!!mod?.permissions) return !!mod?.permissions?.length;
    else {
      const feature = mod?.features?.find(({ id }) => id === item?.featureId);

      return !!feature?.permissions?.length;
    }
  };

  return (
    <>
      <ListItem
        divider
        style={{
          backgroundColor: !role?.isActive ? "#ff00000f" : "#fff",
        }}
      >
        <ListItemText
          primary={
            <span className="d-flex justify-content-between">
              <strong className="text-primary">
                {index + 1}: {role?.id}{" "}
                {!role?.isActive && (
                  <span className="badge badge-danger">Disabled</span>
                )}
              </strong>

              <span className="d-flex align-items-center">
                <span className="badge badge-pill">
                  <small>
                    {role.id === "ADMIN" ? (
                      <strong className="text-success">GLOBAL ACCESS</strong>
                    ) : (
                      role.accessLevel
                    )}
                  </small>
                </span>

                <IconButton
                  size="small"
                  onClick={handleOpenMenu}
                  disabled={role.id === "ADMIN"}
                >
                  <span className="material-icons">more_vert</span>
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  id="account-menu"
                  open={open}
                  onClose={handleCloseMenu}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      mt: 1.5,
                      "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 2,
                      },
                      "&:before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 15,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                  <span>
                    <MenuItem
                      disabled={loading}
                      onClick={() => {
                        handleCloseMenu();

                        const roleFeatures = {};

                        role.modules.forEach((mod) => {
                          if (!!mod.features) {
                            mod.features.forEach((feature) => {
                              roleFeatures[feature.id] = true;
                            });
                          } else roleFeatures[mod.id] = true;
                        });

                        setFormData({
                          id: role.id,
                          accessLevel: role.accessLevel,
                          isActive: role.isActive,
                          roleFeatures,
                        });

                        setEdit(true);
                        setShowAdd(true);
                      }}
                      className={`text-primary`}
                    >
                      <span className="material-icons mr-2">edit</span>
                      Edit Features
                    </MenuItem>
                  </span>

                  <span>
                    <MenuItem
                      disabled={loading}
                      onClick={() => {
                        handleCloseMenu();
                        setShowConfirmDisable(true);
                      }}
                      className={`text-${
                        !role?.isActive ? "success" : "danger"
                      } font-weight-light`}
                    >
                      {role?.isActive && (
                        <span className="material-icons mr-2">close</span>
                      )}
                      {!role?.isActive && (
                        <span className="material-icons mr-2">check</span>
                      )}
                      {role?.isActive ? "Disable" : "Enable"}
                    </MenuItem>
                  </span>
                </Menu>
              </span>
            </span>
          }
          secondary={
            <span className="d-block mt-n3">
              {role?.modules.map((mod) => (
                <span className="d-block" key={mod.id}>
                  <span className="badge">
                    {!!mod.features && (
                      <i className="fa fa-chevron-right" aria-hidden="true"></i>
                    )}{" "}
                    {mod.name}
                    {mod.permissions?.map((permission) => (
                      <span
                        key={permission.id}
                        className="badge badge-success ml-1"
                        style={{ borderRadius: "0px" }}
                      >
                        {permission.permission}
                      </span>
                    ))}
                    <>
                      {!mod.features && !mod.permissions?.length && (
                        <span
                          className="badge badge-secondary ml-1"
                          style={{ borderRadius: "0px" }}
                        >
                          Read Only
                        </span>
                      )}
                      {!!hasFeaturePermissions({
                        moduleId: mod.id,
                        featureId: mod.id,
                      }) && (
                        <IconButton
                          size="small"
                          color="primary"
                          className="ml-1 border p-0"
                          onClick={() =>
                            setSelectedFeature({
                              role: role.id,
                              moduleId: mod.id,
                              featureId: mod.id,
                              permissions: mod.permissions,
                            })
                          }
                        >
                          <MoreHorizIcon style={{ fontSize: "14px" }} />
                        </IconButton>
                      )}
                    </>
                  </span>
                  <span className="d-block ml-3">
                    {mod.features
                      ?.sort((a, b) => {
                        return a.orderNo - b.orderNo;
                      })
                      .map((feature) => (
                        <span className="d-block" key={feature.id}>
                          <span
                            className="badge btn-link"
                            style={{ textDecoration: "none" }}
                          >
                            {feature.name}
                            {feature.permissions.map((permission) => (
                              <span
                                key={permission.id}
                                className="badge badge-success ml-1"
                                style={{ borderRadius: "0px" }}
                              >
                                {permission.permission}
                              </span>
                            ))}
                            {!feature.permissions?.length && (
                              <span
                                className="badge badge-secondary ml-1"
                                style={{ borderRadius: "0px" }}
                              >
                                Read Only
                              </span>
                            )}
                            {!!hasFeaturePermissions({
                              moduleId: mod.id,
                              featureId: feature.id,
                            }) && (
                              <IconButton
                                size="small"
                                color="primary"
                                className="ml-1 border p-0"
                                onClick={() =>
                                  setSelectedFeature({
                                    role: role.id,
                                    moduleId: mod.id,
                                    featureId: feature.id,
                                    permissions: feature.permissions,
                                  })
                                }
                              >
                                <MoreHorizIcon style={{ fontSize: "14px" }} />
                              </IconButton>
                            )}
                          </span>
                        </span>
                      ))}
                  </span>
                </span>
              ))}

              {!role?.modules?.length && role.id !== "ADMIN" && (
                <span className="d-block">
                  <span className="badge badge-pill">
                    <i className="fa fa-chevron-right" aria-hidden="true"></i>{" "}
                    <small className="text-danger ">No feature set</small>
                    <Button
                      size="small"
                      variant="contained"
                      className="p-0 px-1 ml-1"
                      style={{ fontSize: "10px" }}
                      onClick={() => {
                        const roleFeatures = {};

                        role.modules.forEach((mod) => {
                          if (!!mod.features) {
                            mod.features.forEach((feature) => {
                              roleFeatures[feature.id] = true;
                            });
                          } else roleFeatures[mod.id] = true;
                        });

                        setFormData({
                          id: role.id,
                          accessLevel: role.accessLevel,
                          isActive: role.isActive,
                          roleFeatures,
                        });

                        setEdit(true);
                        setShowAdd(true);
                      }}
                    >
                      Set Features
                    </Button>
                  </span>
                </span>
              )}
            </span>
          }
        />
      </ListItem>

      {!!selectedFeature && (
        <FeaturePemissions
          userModules={userModules}
          loading={loading}
          selectedFeature={selectedFeature}
          setSelectedFeature={setSelectedFeature}
          onClose={() => setSelectedFeature(null)}
          saveRolePermissions={saveRolePermissions}
        />
      )}

      {showConfirmDisable && (
        <ConfirmationDialog
          confirmationDialog={showConfirmDisable}
          message={
            <>
              Are you sure you want to{" "}
              <strong
                className={`text-${role?.isActive ? "danger" : "success"}`}
              >
                {role?.isActive ? "disable" : "enable"}
              </strong>{" "}
              this role?
            </>
          }
          setConfirmationDialog={setShowConfirmDisable}
          noPreFormat={true}
          onYes={() => {
            changeRoleStatus(
              {
                id: role?.id,
                isActive: !role?.isActive,
              },
              () => setShowConfirmDisable(false),
            );
          }}
        />
      )}
    </>
  );
};

const AddOrEditRole = (props) => {
  const {
    loading,
    showAdd,
    formData,
    setFormData,
    onClose,
    saveRole,
    edit,
    userModules,
  } = props;

  const onSave = () => {
    saveRole(
      {
        id: formData.id,
        accessLevel: formData.accessLevel,
        roleFeatures: formData.roleFeatures,
        isActive: formData.isActive,
      },
      () => onClose(),
    );
  };

  return (
    <Dialog onClose={onClose} open={showAdd} fullWidth maxWidth="md">
      <DialogTitle className="text-primary">
        <Typography variant="p" noWrap component="div">
          <span className="text-primary">
            {edit ? "Edit " : "Add New "} Role
          </span>
        </Typography>

        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <span className="material-icons">close</span>
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            minHeight: "5vh",
          }}
        >
          <TextField
            style={{ backgroundColor: !!edit ? "#eee" : "#fff" }}
            autoFocus={!edit}
            InputProps={{ readOnly: !!edit }}
            fullWidth
            size="small"
            name="role"
            label={`Role`}
            placeholder={`Role`}
            variant="outlined"
            className="mt-3"
            value={formData.id || ""}
            onChange={(e) => {
              setFormData({
                ...formData,
                id: (e.target.value || "").toUpperCase().replace(" ", "_"),
              });
            }}
          />

          <Autocomplete
            style={{ backgroundColor: !!edit ? "#eee" : "#fff" }}
            readOnly={!!edit}
            className="mt-3"
            size="small"
            defaultValue={[]}
            value={formData.accessLevel}
            options={["PROVINCE", "DISTRICT", "SECTOR", "SCHOOL"]}
            isOptionEqualToValue={(option, value) => option === value}
            getOptionLabel={(option) => option}
            renderOption={(props, accessLevel) => (
              <Box component="li" {...props}>
                {accessLevel}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                onKeyDown={(e) => e.preventDefault()}
                {...params}
                name="accessLevel"
                label="Access Level"
                placeholder="Access Level"
                inputProps={{
                  ...params.inputProps,
                }}
              />
            )}
            onChange={(event, accessLevel) => {
              setFormData({
                ...formData,
                accessLevel: accessLevel || null,
              });
            }}
          />

          <fieldset className={` px-2 form-group border mt-2`}>
            <legend
              className={`col-12 w-auto px-2 text-primary`}
              style={{
                fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                fontWeight: 400,
                fontSize: "0.82rem",
                lineHeight: "1em",
                letterSpacing: "0.00938em",
              }}
            >
              Role Features
            </legend>
            <ul
              className="row  px-0 mx-0 border bg-light"
              style={{ listStyle: "none" }}
            >
              {userModules.map(
                (mod) =>
                  !!mod.features && (
                    <li key={mod.id} className="col-4 my-2">
                      {mod.name}
                      <ul style={{ listStyle: "none" }}>
                        {mod.features?.map((feature) => (
                          <li key={feature.id}>
                            <span className="form-group form-check mb-0">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={feature.id}
                                checked={!!formData.roleFeatures[feature.id]}
                                onChange={(e) => {
                                  const roleFeatures = {
                                    ...formData.roleFeatures,
                                  };

                                  if (e.target.checked)
                                    roleFeatures[feature.id] = true;
                                  else delete roleFeatures[feature.id];

                                  setFormData({
                                    ...formData,
                                    roleFeatures,
                                  });
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={feature.id}
                              >
                                {feature.name}
                              </label>
                            </span>
                          </li>
                        ))}
                      </ul>
                    </li>
                  ),
              )}
              <p className="col-4">
                {userModules.map(
                  (mod) =>
                    !mod.features && (
                      <li key={mod.id}>
                        <span className="form-group form-check mb-0">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={mod.id}
                            checked={!!formData.roleFeatures[mod.id]}
                            onChange={(e) => {
                              const roleFeatures = {
                                ...formData.roleFeatures,
                              };

                              if (e.target.checked) roleFeatures[mod.id] = true;
                              else delete roleFeatures[mod.id];

                              setFormData({
                                ...formData,
                                roleFeatures,
                              });
                            }}
                          />
                          <label className="form-check-label" htmlFor={mod.id}>
                            {mod.name}
                          </label>
                        </span>
                      </li>
                    ),
                )}
              </p>
            </ul>
          </fieldset>
        </div>
      </DialogContent>
      <DialogActions className="d-flex justify-content-center py-4">
        <Button
          variant="contained"
          color="primary"
          onClick={onSave}
          type="button"
          className="px-5"
          disabled={loading || !formData.id || !formData?.accessLevel}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const FeaturePemissions = (props) => {
  const {
    loading,
    onClose,
    selectedFeature,
    setSelectedFeature,
    userModules,
    saveRolePermissions,
  } = props;

  const [permissions, setPermissions] = useState([]);

  const [formData, setFormData] = useState({
    role: selectedFeature.role,
    featureId: selectedFeature.featureId,
    permissions: {},
  });

  useEffect(() => {
    const mod = userModules.find(({ id }) => id === selectedFeature.moduleId);

    if (!!mod.permissions) setPermissions(mod.permissions);
    else {
      const feature = mod.features.find(
        ({ id }) => id === selectedFeature.featureId,
      );
      setPermissions(feature.permissions);
    }
  }, []);

  useEffect(() => {
    const tmpPermissions = { ...formData.permissions };

    selectedFeature.permissions.forEach((permission) => {
      if (permissions.find(({ id }) => id === permission.id))
        tmpPermissions[permission.id] = true;
    });

    setFormData({ ...formData, permissions: tmpPermissions });
  }, [permissions, setSelectedFeature]);

  const onSave = () => {
    saveRolePermissions(
      {
        role: formData.role,
        featureId: formData.featureId,
        permissions: formData.permissions,
      },
      () => onClose(),
    );
  };

  return (
    <Dialog onClose={onClose} open={!!selectedFeature} fullWidth maxWidth="xs">
      <DialogTitle className="text-primary">
        <Typography variant="p" noWrap component="div">
          <span className="text-primary">Pemissions</span>
        </Typography>

        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <span className="material-icons">close</span>
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            minHeight: "5vh",
          }}
        >
          <fieldset className={` px-2 form-group border mt-2`}>
            <legend
              className={`col-12 w-auto px-2 text-primary`}
              style={{
                fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                fontWeight: 400,
                fontSize: "0.82rem",
                lineHeight: "1em",
                letterSpacing: "0.00938em",
              }}
            >
              {selectedFeature.featureId}
            </legend>
            <ul style={{ listStyle: "none" }}>
              {permissions?.map((permission) => (
                <li key={permission.id}>
                  <span className="form-group form-check mb-0">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={permission.id}
                      checked={!!formData.permissions[permission.id]}
                      onChange={(e) => {
                        const permissions = {
                          ...formData.permissions,
                        };

                        if (e.target.checked) permissions[permission.id] = true;
                        else delete permissions[permission.id];
                        setFormData({
                          ...formData,
                          permissions,
                        });
                      }}
                    />
                    <label className="form-check-label" htmlFor={permission.id}>
                      {permission.permission}
                    </label>
                  </span>
                </li>
              ))}
            </ul>
            {!permissions?.length && (
              <div className="jumbotron jumbotron-fluid text-center">
                <div className="container">
                  <p className="lead">{"No permission is available"}</p>
                </div>
              </div>
            )}
          </fieldset>
        </div>
      </DialogContent>
      <DialogActions className="d-flex justify-content-center py-4">
        <Button
          variant="contained"
          color="primary"
          onClick={onSave}
          type="button"
          className="px-5"
          disabled={
            loading ||
            isEmpty(permissions) ||
            (isEmpty(formData.permissions) &&
              isEmpty(selectedFeature.permissions))
          }
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
